import React from 'react';

interface BundleWorkStatBoxProps {
  readonly label: string;
  readonly value: number | string;
}

function BundleWorkStatBox({ label, value }: BundleWorkStatBoxProps): React.ReactElement {
  return (
    <div className="bwo-stat-box" aria-label={`${label} ${value}`}>
      <span className="bwo-stat-label">{label}</span>
      <span className="bwo-stat-value">{value}</span>
    </div>
  );
}

export default BundleWorkStatBox;
